import {
  IArrangeItemsTaskSession,
  IArrangeWordsTaskSession,
  IAuditionTaskSession,
  IDictationTask,
  IDictationTaskSession,
  IFillSentenceGapTask,
  IFillSentenceGapTaskSession,
  IImageHotspotTaskSession,
  IImageObjectTaskSession,
  IInlineDropdownTask,
  IInlineDropdownTaskSession,
  IMarkWordAudioTask,
  IMarkWordAudioTaskSession,
  IMarkWordTask,
  IMarkWordTaskSession,
  IMinimalPairsTask,
  IMinimalPairsTaskSession,
  IPlayArrangeItemsTask,
  IPlayArrangeWordsTask,
  IPlayAuditionTask,
  IPlayImageHotspotTask,
  IPlayImageObjectTask,
  IWordGamesTask,
  IWordGamesTaskSession,
  tPlayTaskType
} from 'common/modules/ReactShared';

import PlayWordGames from 'students/views/pages/LessonTasks/TaskSubjects/Play/Tasks/WordGamesTask';
import PlayArrangeItemsTask from './ArrangeItemsTask';
import PlayArrangeWordsTask from './ArrangeWordsTask';
import PlayAuditionTask from './AuditionTask';
import PlayDictationTask from './DictationTask';
import PlayFillSentenceGapTask from './FillSentenceGap';
import PlayImageHotspotTask from './ImageHotspotTask';
import PlayImageObjectTask from './ImageObjectTask';
import PlayInlineDropdownTask from './InlineDropdownTask';
import PlayMarkWordAudioTask from './MarkWordAudioTask';
import PlayMarkWordTask from './MarkWordTask';
import PlayMinimalPairsTask from './MinimalPairsTask';
import { IPlayTaskProps, tPlayTaskComponentType } from './types';

export type tPlayComponentType =
  | tPlayTaskComponentType<
      IPlayTaskProps<IPlayArrangeItemsTask, IArrangeItemsTaskSession>
    >
  | tPlayTaskComponentType<
      IPlayTaskProps<IPlayArrangeWordsTask, IArrangeWordsTaskSession>
    >
  | tPlayTaskComponentType<
      IPlayTaskProps<IInlineDropdownTask, IInlineDropdownTaskSession>
    >
  | tPlayTaskComponentType<
      IPlayTaskProps<IFillSentenceGapTask, IFillSentenceGapTaskSession>
    >
  | tPlayTaskComponentType<IPlayTaskProps<IMarkWordTask, IMarkWordTaskSession>>
  | tPlayTaskComponentType<IPlayTaskProps<IMarkWordAudioTask, IMarkWordAudioTaskSession>>
  | tPlayTaskComponentType<IPlayTaskProps<IMinimalPairsTask, IMinimalPairsTaskSession>>
  | tPlayTaskComponentType<IPlayTaskProps<IPlayImageObjectTask, IImageObjectTaskSession>>
  | tPlayTaskComponentType<
      IPlayTaskProps<IPlayImageHotspotTask, IImageHotspotTaskSession>
    >
  | tPlayTaskComponentType<IPlayTaskProps<IPlayAuditionTask, IAuditionTaskSession>>
  | tPlayTaskComponentType<IPlayTaskProps<IWordGamesTask, IWordGamesTaskSession>>
  | tPlayTaskComponentType<IPlayTaskProps<IDictationTask, IDictationTaskSession>>;

export const playTaskMap = new Map<tPlayTaskType['type'], tPlayComponentType>([
  ['Tasks::ArrangeItems', PlayArrangeItemsTask],
  ['Tasks::ArrangeWords', PlayArrangeWordsTask],
  ['Tasks::Audition', PlayAuditionTask],
  ['Tasks::Dictation', PlayDictationTask],
  ['Tasks::InlineDropdown', PlayInlineDropdownTask],
  ['Tasks::FillGap', PlayFillSentenceGapTask],
  ['Tasks::MarkWord', PlayMarkWordTask],
  ['Tasks::MarkWordAudio', PlayMarkWordAudioTask],
  ['Tasks::SelectVideo', PlayMinimalPairsTask],
  ['Tasks::ImageObject', PlayImageObjectTask],
  ['Tasks::ImageHotspot', PlayImageHotspotTask],
  ['Tasks::WordGames', PlayWordGames]
]);
